import { createSlice } from "@reduxjs/toolkit";
import { deleteAdvertisement, getAdvertisement } from "./Advertisement.api";

const commityMemberSlice = createSlice({
  name: "advertisement",
  initialState: {
    advertisement: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.surname.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET Banner FILTER WISE DATA
    builder.addCase(getAdvertisement.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAdvertisement.fulfilled, (state, action) => {
      state.loading = false;
      state.advertisement = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getAdvertisement.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteAdvertisement.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteAdvertisement.fulfilled, (state, action) => {
      const deletedId = action.payload.deletedId;

      if (state.advertisement.data) {
        state.advertisement.data = state.advertisement.data.filter(
          (advertisement) => {
            return advertisement._id !== deletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.advertisement.data is not an array:",
          state.advertisement.data
        );
      }
      state.loading = false;
    });

    builder.addCase(deleteAdvertisement.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = commityMemberSlice.actions;
export default commityMemberSlice.reducer;
